<ng-container *transloco="let t">
  @if (dialog()?.opened && dialog()?.component) {
    <ng-container *ngComponentOutlet="dialog()?.component || null; inputs: dialog()?.data" />
  }
  @if (dialog()?.opened && dialog()?.config && !dialog()?.component) {
    <cw-dialog
      [open]="true"
      [dialogTitle]="t(dialog()!.config!.title || '')"
      [size]="dialog()!.config!.size || DialogSizes.S">
      @if (dialog()!.config!.description) {
        <p class="m-0">{{ t(dialog()!.config!.description!) }}</p>
      }
      @if (dialog()!.config!.template) {
        <ng-container *ngTemplateOutlet="dialog()!.config!.template!"></ng-container>
      }

      <div slot="footer">
        @if (dialog()!.config!.cancelButton) {
          <cw-button button-color="secondary" variant="outlined" (click)="close()">{{
            t(dialog()!.config!.cancelButton!)
          }}</cw-button>
        }
        @if (dialog()!.config!.confirmButton) {
          <cw-button button-color="accent" class="dialog-confirm-button" (click)="close(true)">{{
            t(dialog()!.config!.confirmButton!)
          }}</cw-button>
        }
      </div>
    </cw-dialog>
  }
</ng-container>
